export default function (umbrella) {
  var cache = {};
  var get = function get(key) {
    var hit = cache[key];
    if (hit) {
      return hit.value;
    }
  };
  var set = function set(key, value, lifetimeMins) {
    // if key already exists, cancel its already-running timeout
    var hit = cache[key];
    if (hit && hit.timeout !== undefined) {
      clearTimeout(hit.timeout);
    }

    // set cache value
    cache[key] = {
      value: value,
      timeout: !isNaN(lifetimeMins)
      // 1000 * 60 * lifetimeMins = 1 minute
      // this sets the cache to 5 minutes
      ? setTimeout(function () {
        return delete cache[key];
      }, 1000 * 60 * lifetimeMins * 5) : undefined
    };
    return value;
  };
  var remove = function remove(key) {
    var hit = cache[key];
    if (hit) {
      // remove timeout before removing cache
      if (hit.timeout !== undefined) {
        clearTimeout(hit.timeout);
      }
      delete cache[key];
    }
  };
  var clear = function clear() {
    // remove timeouts & cache
    Object.keys(cache).forEach(function (key) {
      remove(key);
    });
  };
  var clearByKey = function clearByKey(key) {
    remove(key);
  };
  var clearByKeyStartsWith = function clearByKeyStartsWith(partialKey) {
    Object.keys(cache).forEach(function (key) {
      if (key.startsWith(partialKey)) {
        remove(key);
      }
    });
  };
  umbrella.cache = {
    get: get,
    set: set,
    remove: remove,
    clear: clear,
    clearByKey: clearByKey,
    clearByKeyStartsWith: clearByKeyStartsWith
  };
}
//# sourceMappingURL=cache.js.map